"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Success = void 0;
var react_1 = __importDefault(require("react"));
var benefits_json_1 = __importDefault(require("./benefits.json"));
var Success_module_scss_1 = __importDefault(require("./Success.module.scss"));
var Benefits_1 = require("../../components/benefits/Benefits");
var react_router_dom_1 = require("react-router-dom");
var Success = function () {
    var state = (0, react_router_dom_1.useLocation)().state;
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "".concat(Success_module_scss_1.default.success, " page") },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h1", { className: "page__title" }, "\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u0437\u0430\u044F\u0432\u043A\u0443!"),
                react_1.default.createElement("h2", { className: Success_module_scss_1.default.success__subtitle }, state.from)),
            react_1.default.createElement("div", { className: Success_module_scss_1.default.success__description },
                react_1.default.createElement("p", null,
                    state.user_name,
                    ", \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435. \u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0430!"),
                react_1.default.createElement("p", null, "\u041C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0441\u0432\u044F\u0436\u0435\u0442\u0441\u044F \u0441 \u0432\u0430\u043C\u0438 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F. \u0421\u043F\u0430\u0441\u0438\u0431\u043E, \u0447\u0442\u043E \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u043D\u0430\u0441!")),
            react_1.default.createElement(Benefits_1.Benefits, { benefits: benefits_json_1.default }))));
};
exports.Success = Success;
